import { HTMLProps } from 'react';
import { useIsMobile } from '~/components/Breakpoint/Breakpoint.hook';

export type TermLinkProps = HTMLProps<HTMLAnchorElement>;

export const TermLink = (props: TermLinkProps) => {
  const isMobile = useIsMobile();

  return <a target={isMobile ? '_self' : '_blank'} {...props} />;
};
